'use client';

import { forwardRef } from 'react';
import { BaseClawInputView, type ChatInputProps, type ChatInputRef } from './BaseClawInputView';

/**
 * Welcome 场景下的输入入口（`/claw` 无 sessionId）。
 *
 * 阶段 3：仅作为 `BaseClawInputView` 的薄壳 forwardRef 包装，保持外部 props/ref 形状不变；
 * 欢迎态特有的 placeholder、首次发送、quick prompt 配置将在后续阶段统一收敛进来。
 *
 * 不要在这里复制基础输入视图的实现，所有共享行为继续走 `BaseClawInputView`。
 */
export type WelcomeChatInputProps = ChatInputProps;
export type WelcomeChatInputRef = ChatInputRef;

export const WelcomeChatInput = forwardRef<WelcomeChatInputRef, WelcomeChatInputProps>((props, ref) => (
  <BaseClawInputView ref={ref} {...props} />
));

WelcomeChatInput.displayName = 'WelcomeChatInput';
